export class DipRegistrationAlertState {
  constructor(
    readonly isEnabled: boolean = null,
    readonly type: string = null,
    readonly messageKey: string = null,
    readonly titleKey: string = null
  ) {
  }
}
